import { View } from '@react-pdf/renderer'
import React from 'react'
import { PDF_VALUE_MIN_PRESENCE_AHEAD } from './PDFCommon'
import { pdfTableRowStyle } from './PdfTableStyles'

interface PdfSplittableTableRowProps {
  children: React.ReactNode
}

/**
 * PDF table row that may split between pages, for rows with content of unknown length which can
 * exceed a whole page.
 */
export const PdfSplittableTableRow = ({
  children
}: PdfSplittableTableRowProps): React.ReactElement => (
  <>
    <View minPresenceAhead={PDF_VALUE_MIN_PRESENCE_AHEAD} />
    <View style={pdfTableRowStyle}>{children}</View>
  </>
)
